import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=0cc40a82&"
import script from "./Titles.vue?vue&type=script&lang=js&"
export * from "./Titles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports